export const CategoryList = [
  {
    id: 1,
    title: '电影',
    slug: 'movie',
    link: '/movie',
    ranklink: '/rank/movie',
    cid: '0,1,3',
    sysKey:"film",
    selectable:true,
    filterKey:["movie","movies"],
    subcate: [
      {
        title: "喜剧",
        routerLink: "/list/movie-19",
        params: {
        }
      },
      {
        title: "爱情",
        routerLink: "/list/movie-20",
        params: {
        }
      },
      {
        title: "动作",
        routerLink: "/list/movie-21",
        params: {
        }
      },
      {
        title: "犯罪",
        routerLink: "/list/movie-22",
        params: {
        }
      },
      {
        title: "科幻",
        routerLink: "/list/movie-23",
        params: {
        }
      },
      {
        title: "奇幻",
        routerLink: "/list/movie-24",
        params: {
        }
      },
      {
        title: "冒险",
        routerLink: "/list/movie-25",
        params: {
        }
      },
      {
        title: "更多",
        routerLink: "/list/movie",
      },
    ],
  },
  {
    id: 2,
    title: '电视剧',
    slug: 'drama',
    link: '/drama',
    ranklink: '/rank/tv',
    cid: '0,1,4',
    sysKey:"tv",
    selectable:true,
    filterKey:["tv-series","drama"],
    subcate: [
      {
        title: "国产剧",
        routerLink: "/list/drama",
        params: {
          region: "大陆",
        }
      },
      {
        title: "港剧",
        routerLink: "/list/drama",
        params: {
          region: "香港",
        }
      },
      {
        title: "台剧",
        routerLink: "/list/drama",
        params: {
          region: "台湾",
        }
      },
      {
        title: "日剧",
        routerLink: "/list/drama",
        params: {
          region: "日本",
        }
      },
      {
        title: "韩剧",
        routerLink: "/list/drama",
        params: {
          region: "韩国",
        }
      },
      {
        title: "欧美剧",
        routerLink: "/list/drama",
        params: {
          region: "欧美",
        }
      },
      {
        title: "英剧",
        routerLink: "/list/drama",
        params: {
          region: "英国",
        }
      },
      {
        title: "更多",
        routerLink: "/list/drama",
      },
    ],
  },
  {
    id: 3,
    title: '综艺',
    slug: 'variety',
    link: '/variety',
    ranklink: '/rank/variety',
    cid: '0,1,5',
    selectable:true,
    subcate: [
      {
        title: "真人秀",
        routerLink: "/list/variety-39",
        params: {
        }
      },
      {
        title: "选秀",
        routerLink: "/list/variety-38",
        params: {
        }
      },
      {
        title: "网综",
        routerLink: "/list/variety-94",
        params: {
        }
      },
      {
        title: "脱口秀",
        routerLink: "/list/variety-43",
        params: {
        }
      },
      {
        title: "搞笑",
        routerLink: "/list/variety-40",
        params: {
        }
      },
      {
        title: "竞技",
        routerLink: "/list/variety-91",
        params: {
        }
      },
      {
        title: "情感",
        routerLink: "/list/variety-33",
        params: {
        }
      },
      {
        title: "更多",
        routerLink: "/list/variety",
      },
    ],
  },
  {
    id: 4,
    title: '动漫',
    slug: 'anime',
    link: '/anime',
    ranklink: '/rank/anime',
    cid: '0,1,6',
    selectable:true,
    subcate: [
      {
        title: "热血",
        routerLink: "/list/anime-46",
        params: {
        }
      },
      {
        title: "格斗",
        routerLink: "/list/anime-47",
        params: {
        }
      },
      {
        title: "机战",
        routerLink: "/list/anime-48",
        params: {
        }
      },
      {
        title: "少女",
        routerLink: "/list/anime-49",
        params: {
        }
      },
      {
        title: "竞技",
        routerLink: "/list/anime-51",
        params: {
        }
      },
      {
        title: "科幻",
        routerLink: "/list/anime-52",
        params: {
        }
      },
      {
        title: "魔幻",
        routerLink: "/list/anime-53",
        params: {
        }
      },
      {
        title: "更多",
        routerLink: "/list/anime",
      },
    ],
  },
  {
    id: 155,
    title: '短剧',
    slug: 'drama-short',
    link: '/list',
    cid: 'drama-short',
    selectable: true,
    navOnly: true,
  },
  {
    id: 5,
    title: '体育',
    slug: 'sport',
    link: '/list',
    linkParams: {
      cid: '0,1,95',
    },
    cid: '0,1,95',
    selectable:true,
    navOnly:true,
  },
  {
    id: 6,
    title: '纪录片',
    slug: 'documentary',
    link: '/documentary',
    cid: '0,1,7',
    selectable:true,
    navOnly:true,
  },
  {
    id: 7,
    title: '华人',
    slug: 'chinese',
    link: '/short-videos',
    cid: 'chinese',
    tagFilter: true,
    selectable: true,
    subcate: [
      {
        title: "留学",
        routerLink: "/list/chinese",
        params: {
          tag: '留学',
        }
      },
      {
        title: "生活",
        routerLink: "/list/chinese",
        params: {
          tag: '生活',
        }
      },
      {
        title: "活动",
        routerLink: "/list/chinese",
        params: {
          tag: '活动',
        }
      },
      {
        title: "演出",
        routerLink: "/list/chinese",
        params: {
          tag: '演出',
        }
      },
      {
        title: "推广",
        routerLink: "/list/chinese",
        params: {
          tag: '推广',
        }
      },
      {
        title: "更多",
        routerLink: "/list/chinese",
      },
    ],
  },
  {
    id: 8,
    title: '游戏',
    slug: 'game',
    link: '/short-videos',
    cid: 'game',
    sysKey:"games",
    tagFilter: true,
    selectable: true,
    subcate: [
      {
        title: "电竞",
        routerLink: "/list/game",
        params: {
          tag: '电竞',
        }
      },
      {
        title: "网游",
        routerLink: "/list/game",
        params: {
          tag: '网游',
        }
      },
      {
        title: "单机",
        routerLink: "/list/game",
        params: {
          tag: '单机',
        }
      },
      {
        title: "主机",
        routerLink: "/list/game",
        params: {
          tag: '主机',
        }
      },
      {
        title: "手游",
        routerLink: "/list/game",
        params: {
          tag: '手游',
        }
      },
      {
        title: "更多",
        routerLink: "/list/game",
      },
    ],
  },
  // {
  //   id:9,
  //   title:"频道",
  //   slug:"channel",
  //   link:"/list",
  //   cid: 'channel',
  //   tagFilter:true
  // },
  // {
  //   id:10,
  //   title:"头条",
  //   slug:"top",
  //   link:"/list",
  //   tagFilter:true,
  //   cid:"top",
  //   navOnly:true ///仅仅作为导航

  // },
  {
    id:11,
    title:"新闻",
    slug:"news",
    link:"/short-videos",
    tagFilter:true,
    cid:"news",
    selectable:true,
    subcate: [
      {
        title: "国际新闻",
        routerLink: "/list/news",
        params: {
          tag: '国际新闻',
        }
      },
      {
        title: "中国新闻",
        routerLink: "/list/news",
        params: {
          tag: '中国新闻',
        }
      },
      {
        title: "华人资讯",
        routerLink: "/list/news",
        params: {
          tag: '华人资讯',
        }
      },
      {
        title: "财经",
        routerLink: "/list/news",
        params: {
          tag: '财经',
        }
      },
      {
        title: "军事",
        routerLink: "/list/news",
        params: {
          tag: '军事',
        }
      },
      {
        title: "更多",
        routerLink: "/list/news",
      },
    ],
  },
  {
    id:12,
    title:"娱乐",
    slug:"yule",
    link:"/short-videos",
    tagFilter:true,
    cid:"yule",
    selectable:true,
    subcate: [
      {
        title: "娱乐资讯",
        routerLink: "/list/yule",
        params: {
          tag: '娱乐资讯',
        }
      },
      {
        title: "影视周边",
        routerLink: "/list/yule",
        params: {
          tag: '影视周边',
        }
      },
      {
        title: "明星",
        routerLink: "/list/yule",
        params: {
          tag: '明星',
        }
      },
      {
        title: "达人",
        routerLink: "/list/yule",
        params: {
          tag: '达人',
        }
      },
      {
        title: "动画",
        routerLink: "/list/yule",
        params: {
          tag: '动画',
        }
      },
      {
        title: "更多",
        routerLink: "/list/yule",
      },
    ],
  },
  {
    id:13,
    title:"生活",
    slug:"life",
    link:"/short-videos",
    tagFilter:true,
    cid:"life",
    selectable:true,
    subcate: [
      {
        title: "搞笑",
        routerLink: "/list/life",
        params: {
          tag: '搞笑',
        }
      },
      {
        title: "日常",
        routerLink: "/list/life",
        params: {
          tag: '日常',
        }
      },
      {
        title: "美食",
        routerLink: "/list/life",
        params: {
          tag: '美食',
        }
      },
      {
        title: "动物",
        routerLink: "/list/life",
        params: {
          tag: '动物',
        }
      },
      {
        title: "奇葩",
        routerLink: "/list/life",
        params: {
          tag: '奇葩',
        }
      },
      {
        title: "旅游",
        routerLink: "/list/life",
        params: {
          tag: '旅游',
        }
      },
      {
        title: "知识",
        routerLink: "/list/life",
        params: {
          tag: '知识',
        }
      },
      {
        title: "星座",
        routerLink: "/list/life",
        params: {
          tag: '星座',
        }
      },
      {
        title: "婚恋",
        routerLink: "/list/life",
        params: {
          tag: '婚恋',
        }
      },
      {
        title: "赶海",
        routerLink: "/list/life",
        params: {
          tag: '赶海',
        }
      },
      {
        title: "更多",
        routerLink: "/list/life",
      },
    ],
  },
  {
    id:14,
    title:"音乐",
    slug:"music",
    link:"/short-videos",
    tagFilter:true,
    cid:"music",
    selectable:true,
    subcate: [
      {
        title: "音乐资讯",
        routerLink: "/list/music",
        params: {
          tag: '音乐资讯',
        }
      },
      {
        title: "MV",
        routerLink: "/list/music",
        params: {
          tag: 'MV',
        }
      },
      {
        title: "自创",
        routerLink: "/list/music",
        params: {
          tag: '自创',
        }
      },
      {
        title: "舞蹈",
        routerLink: "/list/music",
        params: {
          tag: '舞蹈',
        }
      },
      {
        title: "歌曲",
        routerLink: "/list/music",
        params: {
          tag: '歌曲',
        }
      },
      {
        title: "现场",
        routerLink: "/list/music",
        params: {
          tag: '现场',
        }
      },
      {
        title: "更多",
        routerLink: "/list/music",
      },
    ],
  },
  {
    id:15,
    title:"时尚",
    slug:"fashion",
    link:"/short-videos",
    tagFilter:true,
    cid:"fashion",
    selectable:true,
    subcate: [
      {
        title: "美妆",
        routerLink: "/list/fashion",
        params: {
          tag: '美妆',
        }
      },
      {
        title: "健身",
        routerLink: "/list/fashion",
        params: {
          tag: '健身',
        }
      },
      {
        title: "秀场",
        routerLink: "/list/fashion",
        params: {
          tag: '秀场',
        }
      },
      {
        title: "写真",
        routerLink: "/list/fashion",
        params: {
          tag: '写真',
        }
      },
      {
        title: "穿搭",
        routerLink: "/list/fashion",
        params: {
          tag: '穿搭',
        }
      },
      {
        title: "更多",
        routerLink: "/list/fashion",
      },
    ],
  },
  {
    id:16,
    title:"科技",
    slug:"tech",
    link:"/short-videos",
    tagFilter:true,
    cid:"tech",
    selectable:true,
    subcate: [
      {
        title: "数码",
        routerLink: "/list/tech",
        params: {
          tag: '数码',
        }
      },
      {
        title: "汽车",
        routerLink: "/list/tech",
        params: {
          tag: '汽车',
        }
      },
      {
        title: "电脑",
        routerLink: "/list/tech",
        params: {
          tag: '电脑',
        }
      },
      {
        title: "手机",
        routerLink: "/list/tech",
        params: {
          tag: '手机',
        }
      },
      {
        title: "武器",
        routerLink: "/list/tech",
        params: {
          tag: '武器',
        }
      },
      {
        title: "更多",
        routerLink: "/list/tech",
      },
    ],
  },
  {
    id:17,
    title:"小视频",
    slug:"svideo",
    link:"/short-videos",
    tagFilter:true,
    cid:"svideo",
    selectable:true
  }
];

export const AdultCategoryList = [
  {
    id: 7,
    title: '原创',
    slug: 'selfLord',
    link: '/list',
    ranklink: '/rank/selflord-18',
    linkParams: {
      cid: '0,2,10,115',
    },
    cid: '0,2,10,115',
    selectable:true
  },
  {
    id: 1,
    title: '日韩',
    slug: 'japanKorea',
    link: '/list',
    ranklink: '/rank/japankorea-18',
    linkParams: {
      cid: '0,2,10,85',
    },
    cid: '0,2,10,85',
    selectable:true
  },
  {
    id: 2,
    title: '欧美',
    slug: 'europe',
    link: '/list',
    ranklink: '/rank/western-18',
    linkParams: {
      cid: '0,2,10,86',
    },
    cid: '0,2,10,86',
    selectable:true
  },
  {
    id: 3,
    title: '国产',
    slug: 'china',
    link: '/list',
    ranklink: '/rank/china-18',
    linkParams: {
      cid: '0,2,10,87',
    },
    cid: '0,2,10,87',
    selectable:true
  },
  {
    id: 4,
    title: '卡通',
    slug: 'cartoon',
    link: '/list',
    ranklink: '/rank/cartoon-18',
    linkParams: {
      cid: '0,2,10,88',
    },
    cid: '0,2,10,88',
    selectable:true
  },
  {
    id: 5,
    title: '其它',
    slug: 'other',
    link: '/list',
    ranklink: '/rank/other-18',
    linkParams: {
      cid: '0,2,10,90',
    },
    cid: '0,2,10,90',
    selectable:true
  },
  {
    id: 6,
    title: 'VR',
    slug: 'vr',
    link: '/list',
    ranklink: '/rank/vr-18',
    linkParams: {
      cid: '0,2,10,112',
    },
    cid: '0,2,10,112',
    selectable:true
  },
];
